import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_heomoney/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_heomoney/layout/core'
import {MasterInit} from '../_heomoney/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ChatSocketProvider} from './modules/herramientas/chat/Context/ChatSocketContext'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <ChatSocketProvider>
              <Outlet />
            </ChatSocketProvider>
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
